import React, { useState } from "react";
import ModalDialog, {
  ModalHeader,
  ModalTitle,
  ModalBody,
} from "@atlaskit/modal-dialog";
import Button from "@atlaskit/button";
import { setLJsonStorage, useDevice } from "../../welcome-dashboard/Utils";
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V3 } from "../../constant";
import { getStore, InvitedUserConfirmFlag, isSocialMobileApp, _startConference, getBaseConfig } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { setInvitedUserConfirm, setInvitedUserMState, setJammingCapabilityState } from '../../redux/tool-webjam-v3/actions';
import { Constant, CURRENT_ROOM_NAME } from "../../../webjam/constant";
import { setPrejoinPageVisibility } from "../../../prejoin/actions.web";
import { setWaitingScreen } from "../../redux/tool-webjam/actions";
import toast from "react-simple-toasts";
import { GenericConfirmationModal } from "./GenericConfirmationModal";
import { Translate } from "../../../webjam/language";
import Dialog from "../../../base/ui/components/web/Dialog";
import { ct } from "../../constant-Utils";

export const JammingCapabilityModal = () => {
  const { isMobile } = useDevice();
  const dispatch = useDispatch();
  const { invitedUserConfirm } = useSelector((state) => state[FEATURE_CUSTOM_REDUX_V3]);
  const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX);

  const [moveToSocialConfirm, setMoveToSocialConfirm] = useState(false);


  const handleClick = (withoutJam) => {
    if (withoutJam) {
      setLJsonStorage("auth", {
        with_jam: false
      })
      dispatch(setInvitedUserConfirm(""));
      if (userLoginData?.user.is_invited == true && !userLoginData?.user?.id) {
        dispatch(setInvitedUserMState(true));
      } else {
        // user join in the room
        dispatch(setInvitedUserConfirm(InvitedUserConfirmFlag.WITHOUT_DEVICE_U_LOGIN));
      }
    } else {
      setLJsonStorage("auth", {
        with_jam: true
      })
      if (userLoginData?.user.is_invited == true && userLoginData?.user?.id) {
        dispatch(setInvitedUserConfirm(""));
        // 22 jun
        const hidePreJoinScreen = getBaseConfig("hidePreJoinScreen");
        if (hidePreJoinScreen && userLoginData?.room?.admin) {
          dispatch(setPrejoinPageVisibility(false, 15));
        } else {
          dispatch(setPrejoinPageVisibility(true, 16));
        }

      } else {
        setMoveToSocialConfirm(true)
        // const socialApp = Constant.App.socialUrl;
        // if (isSocialMobileApp()) {
        //   // currently invite link is not used in mobile app
        //   toast("You can't use invite link in mobile app.");
        // } else {
        //   setMoveToSocialConfirm(true)
        //   window.parent.location.href = socialApp + "?roomname=" + CURRENT_ROOM_NAME + "&login=true&is_invited=true&is_jamming=true";
        // }
      }
    }

  };


  return (
    <>
      {moveToSocialConfirm &&
        <GenericConfirmationModal
          title={ct("rta-trmc.signInSignUpPage.signIn")}
          successBtnName={ct("Translate.buttonTitle.okSmall")}
          cancelBtnName={ct("Translate.buttonTitle.cancelSmall")}
          content={ct("Translate.confirmMessages.confirmSocialRedirect")}
          onSuccess={() => {
            localStorage.removeItem("auth");
            sessionStorage.removeItem("dv_cnf_tm");
            sessionStorage.removeItem("up_time_" + CURRENT_ROOM_NAME);
            localStorage.removeItem('socialAuthToken');
            const socialApp = Constant.App.socialUrl;
            dispatch(setInvitedUserConfirm(""));
            if (isSocialMobileApp()) {
              // currently invite link is not used in mobile app
              toast(ct("Translate.messages.cantUseInviteLink"));
            } else {
              window.parent.location.href = socialApp + "?roomname=" + CURRENT_ROOM_NAME + "&login=true&is_invited=true&is_jamming=true";
            }
          }}
          onCancel={() => {
            setMoveToSocialConfirm(false)
          }} />
      }
      {invitedUserConfirm == InvitedUserConfirmFlag.IS_CONFIRMING && !moveToSocialConfirm &&
        <Dialog
          disableAutoHideOnSubmit={true}
          disableBackdropClose={true}
          hideCloseButton={true}
          cancel={{ hidden: true }}
          ok={{ hidden: true }}
          titleKey={ct("Translate.messages.jammingModalTitle")}
          rtaClassName="jamming-modal-popup"
          testId="jamming-modal-popup"
        >
          <div className={`mt-2 row`} style={{ justifyContent: 'space-between' }}>
            <div className="col-md-6 mb-5">
              <Button id="without-real-time-jamming" onClick={() => handleClick(true)} className="submit-button login-btn-pass join-meeting-pass w-100 without-real-time-jamming">
                {ct("Translate.buttonTitle.withOutRtaJammingCapability")}
              </Button>
              <div className={isMobile ? "mt-2" : "mt-5"} style={{ color: '000' }}>
                <h4>{ct("Translate.typography.noRequirements")}</h4>
              </div>
            </div>
            <div className="col-md-6 mb-5">
              <Button id="with-real-time-jamming" onClick={() => handleClick(false)} className="submit-button login-btn-pass join-meeting-pass mr-2 w-100 with-real-time-jamming">
                {ct("Translate.buttonTitle.withRTAJammingCapability")}
              </Button>
              <div className={isMobile ? "mt-2" : "mt-5"} style={{ color: '000' }}>
                <h4>{ct("Translate.typography.requires")}</h4>
                <ul className="require-list mb-2">
                  <li>{ct("Translate.typography.signInSignUpRequire")}</li>
                  <li>{ct("Translate.messages.RTAPowerDevice")}</li>
                </ul>
              </div>
            </div>
          </div>
        </Dialog>
      }
    </>
  );
};
